import { dispatchData } from '../index';

const updateItsInstalationProtocol = (dispatch, data, task, updatedItsInstallationProtocol) => {
  const tasks = [...data.tasks];
  const taskIndex = data.tasks.indexOf(data.tasks.find(x => x.id === task.id));
  tasks.splice(taskIndex, 1, {
    ...task,
    itsInstalationProtocol: updatedItsInstallationProtocol,
  });

  dispatchData(dispatch, data, tasks);
};

const handleDamageDescriptionChange = (event, dispatch, task, data) => {
  const updatedItsInstalationProtocol = { ...task.itsInstalationProtocol };
  updatedItsInstalationProtocol.damageDescription = event.target.value;

  updateItsInstalationProtocol(dispatch, data, task, updatedItsInstalationProtocol);
};

const handleClientNotAgreedDescriptionChange = (event, dispatch, task, data) => {
  const updatedItsInstalationProtocol = { ...task.itsInstalationProtocol };
  updatedItsInstalationProtocol.clientNotAgreedDescription = event.target.value;

  updateItsInstalationProtocol(dispatch, data, task, updatedItsInstalationProtocol);
};

const toggleProtocolFields = (dispatch, data, task, itsInstalationProtocol) => {
  const updatedInstalationProtocol = { ...itsInstalationProtocol };
  updatedInstalationProtocol.open = !updatedInstalationProtocol.open;

  const updatedTask = {
    ...task,
    itsInstalationProtocol: updatedInstalationProtocol,
  };

  const updatedTasks = [...data.tasks];
  const taskIndex = data.tasks.indexOf(data.tasks.find(x => x.id === task.id));
  updatedTasks.splice(taskIndex, 1, updatedTask);

  dispatchData(dispatch, data, updatedTasks);
};

const toggleDamageDescriptionField = (dispatch, task, data, showField) => {
  let itsInstalationProtocol = { ...task.itsInstalationProtocol };
  let updatedDamageDescriptionField = itsInstalationProtocol.damageDescriptionField;
  let updatedDamageDescription = itsInstalationProtocol.damageDescription;

  if (updatedDamageDescriptionField && updatedDamageDescriptionField === 'no' && showField) {
    updatedDamageDescriptionField = 'yes';
  } else if (
    updatedDamageDescriptionField &&
    updatedDamageDescriptionField === 'yes' &&
    !showField
  ) {
    updatedDamageDescriptionField = 'no';
    updatedDamageDescription = '';
  } else {
    return;
  }

  const updatedTask = {
    ...task,
    itsInstalationProtocol: {
      ...task.itsInstalationProtocol,
      damageDescriptionField: updatedDamageDescriptionField,
      damageDescription: updatedDamageDescription,
    },
  };

  const taskIndex = data.tasks.indexOf(data.tasks.find(x => x.id === task.id));
  const updatedTasks = [...data.tasks];
  updatedTasks.splice(taskIndex, 1, updatedTask);

  dispatchData(dispatch, data, updatedTasks);
};

const toggleAggreedWithPerformedActivitiesDescriptionField = (dispatch, task, data, showField) => {
  let itsInstalationProtocol = { ...task.itsInstalationProtocol };
  let updatedAgreeWithPerformedActivitiesField =
    itsInstalationProtocol.agreeWithPerformedActivitiesField;
  let updatedClientNotAgreedDescription = itsInstalationProtocol.clientNotAgreedDescription;

  if (
    updatedAgreeWithPerformedActivitiesField &&
    updatedAgreeWithPerformedActivitiesField === 'no' &&
    showField
  ) {
    updatedAgreeWithPerformedActivitiesField = 'yes';
  } else if (
    updatedAgreeWithPerformedActivitiesField &&
    updatedAgreeWithPerformedActivitiesField === 'yes' &&
    !showField
  ) {
    updatedAgreeWithPerformedActivitiesField = 'no';
    updatedClientNotAgreedDescription = '';
  } else {
    return;
  }

  const updatedTask = {
    ...task,
    itsInstalationProtocol: {
      ...task.itsInstalationProtocol,
      agreeWithPerformedActivitiesField: updatedAgreeWithPerformedActivitiesField,
      clientNotAgreedDescription: updatedClientNotAgreedDescription,
    },
  };

  const taskIndex = data.tasks.indexOf(data.tasks.find(x => x.id === task.id));
  const updatedTasks = [...data.tasks];
  updatedTasks.splice(taskIndex, 1, updatedTask);

  dispatchData(dispatch, data, updatedTasks);
};

const validateInstalationProtocol = itsInstalationProtocol => {
  let messages = [];
  if (itsInstalationProtocol.damageDescriptionField === 'yes') {
    const errorTextForLessLenght =
      'Моля, опишете с повече от 3 символа нанесените щети при посещението в протокол за инсталация!';
    const errorTextForMoreLength =
      'Описанието за нанесена щета при посещение в протокол за инсталация не може да бъде над 2000 символа';
    messages.push(
      getMessageForField(
        itsInstalationProtocol.damageDescription,
        errorTextForLessLenght,
        errorTextForMoreLength
      )
    );
  }

  if (itsInstalationProtocol.agreeWithPerformedActivitiesField === 'no') {
    const errorTextForLessLenght =
      'Моля, опишете с повече от 3 символа забележките по извършените дейности при посещение в протокол за инсталация!';
    const errorTextForMoreLength =
      'Забележката по извършените дейности при посещение в протокол за инсталация не може да бъде над 2000 символа!';
    messages.push(
      getMessageForField(
        itsInstalationProtocol.clientNotAgreedDescription,
        errorTextForLessLenght,
        errorTextForMoreLength
      )
    );
  }

  return messages;
};

const getMessageForField = (field, errorTextForLessLenght, errorTextForMoreLength) => {
  if (!field || field.length < 3) return errorTextForLessLenght;
  else if (!field && field.length > 2000) return errorTextForMoreLength;
};

export {
  validateInstalationProtocol,
  handleDamageDescriptionChange,
  handleClientNotAgreedDescriptionChange,
  toggleProtocolFields,
  toggleAggreedWithPerformedActivitiesDescriptionField,
  toggleDamageDescriptionField,
};
